<template>
  <v-layout wrap style="margin-top: 70px" align-center justify-center>
    <v-flex xs12 sm4 v-if="packageItem" class="px-2">
      <v-card>
        <v-layout wrap class="pa-3 mb-5">
          <v-flex xs12 class="title text-xs-center pa-2 selectedPackage">Selected Package:</v-flex>

          <v-flex xs12 class="title text-xs-center">{{packageItem.name}}</v-flex>

          <v-flex xs12 class="pt-3">
            <p>{{packageItem.description}}</p>
          </v-flex>

          <v-flex xs12 class="pa-1 title text-xs-center">Features</v-flex>

          <v-flex xs12>
            <ul>
              <li v-for="(feature, index) in packageItem.features" v-bind:key="index">
                <v-icon>arrow_right</v-icon>
                {{feature}}
              </li>
            </ul>
          </v-flex>

          <v-flex xs12 class="mt-3">
            <h4>Selected Option</h4>
            {{selectedTime}} -@ {{selectedCurrency.toUpperCase()}} {{selectedCost}}
          </v-flex>

          <!-- <v-flex xs12 class="text-xs-center">
            <v-btn class="green darken-1" dark to="/packages">
              <v-icon left>edit</v-icon>Change Package
            </v-btn>
          </v-flex> -->

          <v-flex xs12 class="text-xs-center">
            <v-btn class="blue darken-1" dark @click="makePayment">Subscribe VIP Sonko</v-btn>
          </v-flex>
        </v-layout>
      </v-card>
    </v-flex>
  </v-layout>
</template>


<script>
import { mapGetters } from "vuex";
import { host } from "@/common";
export default {
  name: "packagesList",
  computed: {
    ...mapGetters(["user"])
  },
  props: {
    packageItem: {
      type: Object,
      default: {}
    }
  },
  data() {
    return {
      row: null,
      column: null,
      radios: null,
      selectedTime: null,
      selectedCost: null,
      selectedDuration: null,
      selectedCurrency: null,
    };
  },
  methods: {
    makePayment() {
      const userId = this.$route.params.userId;
      const details = {
        userId: userId,
        cost: parseInt(this.$route.query.cost),
        duration: parseInt(this.$route.query.duration),
        packageId: this.packageItem._id,
        optionId: this.$route.params.option,
        packageName: this.packageItem.name,
        packageOption: this.$route.query.time,
        currency: this.$route.query.currency,
      };

      const cost = parseInt(this.$route.query.cost);

      const data = { data: JSON.stringify(details) };
      const self = this;
      console.log(data, 'd');
      const res = this.$store
        .dispatch("post", { url: "/subscription/free", data })
        .then(res => {
          if (res.state == true) {
            self.$router.push('/vip_sonkos');
          }
        });
    }
  },
  created() {
    const time = this.$route.query.time;
    const cost = this.$route.query.cost;
    const duration = this.$route.query.duration;
    this.selectedTime = time;
    this.selectedCost = cost;
    this.selectedDuration = duration;
    this.selectedCurrency = this.$route.query.currency;
  }
};
</script>

<style scoped>
.options {
  border-bottom: 1px solid #eeeeee;
}

ul li {
  list-style: none;
}

.selectedPackage {
  color: orange;
}
</style>